import contact from '../../../public/icons/dyn-crm-entities/contact.svg';
import account from '../../../public/icons/dyn-crm-entities/account.svg';
import lead from '../../../public/icons/dyn-crm-entities/lead.svg';
import { EEntity } from '../enums/entity.enum';

export const getEntityCrmIcon = (type: EEntity) => {
  switch (type) {
    case EEntity.ACCOUNT:
      return account;
    case EEntity.CONTACT:
      return contact;
    case EEntity.LEAD:
      return lead;
    default:
      return null;
  }
};
